import { createRoot } from "react-dom/client";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import App from "./App.tsx";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { supabase } from "./integrations/supabase/client";
import "./index.css";

initSentry();
initPostHog();

// MS393: preflight the Supabase session check so it runs in parallel
// with React's bootstrap (createRoot + render + AuthProvider mount).
// Without this, AuthProvider's useEffect only fires after the whole
// React tree mounts, and the auth-check round-trip becomes serial:
//   mount React → AuthProvider mounts → getSession() round-trip →
//   Login useEffect re-evaluates → form is interactive.
// With the preflight, supabase's internal session cache is warm by
// the time AuthProvider's useEffect runs, so its getSession() call
// resolves from cache instantly. Net effect: Login fields are
// interactive ~200-500ms sooner on a cold load.
//
// Fire-and-forget — we don't await the promise here because React
// bootstrap shouldn't block on it. The promise resolves into the
// supabase client's cache; AuthProvider reads from that cache.
// Errors are swallowed because AuthProvider's own getSession() call
// will surface any actual failure (e.g. network down).
void supabase.auth.getSession().catch(() => {});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
